<template>
  <el-dialog
    :title="$t('evBike.issueTitle')"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false">

    <el-form :model="form" label-width="100px">
      <el-form-item :label="$t('evBike.cardNumber')" required>
        <el-input
          v-model="form.cardNumber"
          :placeholder="$t('evBike.inputCardNumber')"
          maxlength="30"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{ $t('evBike.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('evBike.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { issueEvBike } from '@/api/evbike/evBikeApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'IssueEvBike',
  data() {
    return {
      dialogVisible: false,
      currentBike: {},
      form: {
        cardNumber: ''
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(bike) {
      this.currentBike = { ...bike }
      this.form.cardNumber = ''
      this.dialogVisible = true
    },
    handleCancel() {
      this.dialogVisible = false
      this.form.cardNumber = ''
    },
    async handleConfirm() {
      if (!this.form.cardNumber || this.form.cardNumber.trim() === '') {
        this.$message.warning(this.$t('evBike.inputCardNumber'))
        return
      }

      try {
        const res = await issueEvBike({
          bikeId: this.currentBike.bikeId,
          communityId: this.communityId,
          cardNumber: this.form.cardNumber
        })

        if (res.code == 0) {
          this.$message.success(this.$t('evBike.issueCardSuccess'))
          this.dialogVisible = false
          this.form.cardNumber = ''
          this.$emit('listEvBikeData')
        } else {
          this.$message.error(res.msg || this.$t('evBike.issueCardFailed'))
        }
      } catch (error) {
        this.$message.error(error.message || this.$t('evBike.issueCardFailed'))
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
